import { auth_uri } from '../config/Auth0'

export default async function loginWithRedirect(options) {
  const { type, appState } = options
  const connection = getConnection(type)

  try {
    if (appState) {
      localStorage.setItem('appState', appState)
    }
    const state = encodeURIComponent(
      JSON.stringify({
        redirect_uri: `${window.location.origin}/auth`
      })
    )

    if (connection) {
      window.open(`${auth_uri}?connection=${connection}&state=${state}`, '_self')
    } else {
      window.open(`${auth_uri}?state=${state}`, '_self')
    }
  } catch (error) {
    console.error('Authentication error:', error)
  }
}

const getConnection = type => {
  if (type === 'Username-Password-Authentication') return 'email'
  else return type
}
